// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"72":"QuoteShowRestaurantMenu","179":"Payment","415":"InvoicePayment","756":"Review","789":"ReviewList","812":"QuoteMenu"}[chunkId] + "." + {"72":"d0639bba","179":"fb103523","415":"4251e451","756":"c2462455","789":"d47b94f5","812":"dc1c431b"}[chunkId] + ".css";
};